export const MODES = {
  TEST: "test",
  LIVE: "live"
} as const;